import { PocButton, PocTypography } from 'commons/components/components-wrapper';
import { t } from 'core/i18n/i18n';
import React from 'react';
import styled from 'styled-components';

const ErrorBoundaryContainer = styled.section`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100vh;
`;

interface State {
    hasError: boolean;
}

export class ErrorBoundary extends React.Component<React.PropsWithChildren, State> {
    state: State = { hasError: false };

    static getDerivedStateFromError(_error: unknown): State {
        return { hasError: true };
    }

    render() {
        if (this.state.hasError) {
            return (
                <ErrorBoundaryContainer>
                    <PocTypography variant="title3">{t('commons.components.error-boundary.title')}</PocTypography>
                    <PocTypography variant="body1">{t('commons.components.error-boundary.description')}</PocTypography>
                    <PocButton onClick={() => globalThis.location.reload()}>
                        {t('commons.components.error-boundary.button.reload')}
                    </PocButton>
                </ErrorBoundaryContainer>
            );
        }

        return this.props.children;
    }
}
